import { useState, useEffect } from "react";
import Head from "next/head";
import { PageLayout } from "../../../src/Components/Layout/web";
import { withAuth } from "../../../lib/auth";
import { withApollo } from "../../../lib/apollo3";
import { withContext } from "../../../lib/context";
import { withTranslation } from "../../../shared-components/i18n";
import { withGlobalComponents } from "../../../shared-components/ViewFragments/GlobalComponents/web";
import { Header } from "src/Components/Eventos/Header/web";
import { EventItem } from "src/Components/Eventos/EventItem/web";
import { EventCarousel } from "src/Components/Eventos/EventCarousel/web";
import { useQuery } from "@apollo/client";
import { QUERY_EVENTS } from "shared-components/GQL/EventsQuery";
import "./styles.less"
import { CloseIcon } from "shared-components/Components/CustomIcons/CloseIcon/web";
import dayjs from "dayjs";

const Eventos = () => {
    const { data } = useQuery(QUERY_EVENTS, {});
    const [filteredEvents, setFilteredEvents] = useState([]);
    const [pastEvents, setPastEvents] = useState([]);
    const [futureEvents, setFutureEvents] = useState([]);
    const [isCountryFilterApplied, setIsCountryFilterApplied] = useState(false);
    const [isMonthFilterApplied, setIsMonthFilterApplied] = useState(false);
    const [selectedCountryValue, setSelectedCountryValue] = useState("");
    const [selectedMonthValue, setSelectedMonthValue] = useState("");
    const [visibleEvents, setVisibleEvents] = useState(10);

    useEffect(() => {
        if (data) {
            const currentDate = dayjs().set('hour', 0).set('minute', 0).set('second', 0).set('millisecond', 0);
            const eventsToShow = data.getEvents.filter((event) => (event.image && event.image !== ""))

            const pastEventsFiltered = eventsToShow.filter((event) => event.type !== "3").filter((event) => {
                const eventClosingDate = dayjs(event.endDate);

                return !eventClosingDate.isSame(currentDate) && eventClosingDate.isBefore(currentDate);
            }).sort((a, b) => {
                const first = new Date(a.startDate);
                const second = new Date(b.startDate);

                //@ts-ignore
                return first - second
            });

            const futureEventsFiltered = eventsToShow.filter((event) => event.type !== "3").filter((event) => {
                const eventClosingDate = dayjs(event.endDate);

                return eventClosingDate.isSame(currentDate) || eventClosingDate.isAfter(currentDate);
            }).map((event) => ({ ...event, show: true }))
                .sort((a, b) => {
                    const first = new Date(a.startDate);
                    const second = new Date(b.startDate);

                    //@ts-ignore
                    return first - second
                });

            setFutureEvents(futureEventsFiltered)
            setPastEvents(pastEventsFiltered)
            setFilteredEvents(futureEventsFiltered)
        }
    }, [data]);

    useEffect(() => {
        setFutureEvents((prevEvents) => {
            return prevEvents.map((event) => {
                const fechaInicio = new Date(event.startDate);
                const fechaFin = new Date(event.endDate);

                const isMatchingMonth = selectedMonthValue === '' || (fechaInicio.getUTCMonth() + 1 === Number(selectedMonthValue) || fechaFin.getUTCMonth() + 1 === Number(selectedMonthValue));
                const isMatchingCountry = selectedCountryValue === '' || event.countryId === selectedCountryValue;

                return { ...event, show: isMatchingMonth && isMatchingCountry };
            });
        });
    }, [selectedCountryValue, selectedMonthValue]);

    const handleCountryFilterChange = (e) => {
        const countryValue = e.target.value;
        setSelectedCountryValue(countryValue);
        setIsCountryFilterApplied(countryValue !== '');
    };

    const handleRemoveCountryFilter = () => {
        setIsCountryFilterApplied(false);
        setSelectedCountryValue("");
    }

    const handleMonthFilterChange = (e) => {
        const monthValue = e.target.value;
        setSelectedMonthValue(monthValue);
        setIsMonthFilterApplied(monthValue !== '');
    };

    const handleRemoveMonthFilter = () => {
        setIsMonthFilterApplied(false);
        setSelectedMonthValue("");
    }

    const handleShowMore = () => {
        setVisibleEvents((prevVisibleEvents) => visibleEvents + prevVisibleEvents);
    }

    return (
        <PageLayout classContainer="inmob-container">
            <Header />

            <Head>
                <meta name="robots" content="index,follow" />
            </Head>

            <div className="container">
                <div className="filter-container">
                    <div className="select-container">
                        <select
                            name="countries"
                            id="countries"
                            className="countries-select"
                            onChange={handleCountryFilterChange}
                            value={selectedCountryValue}
                        >
                            <option value="" disabled hidden>Selecciona un país</option>
                            <option value="">Quitar filtro</option>
                            <option value="1">Uruguay</option>
                            <option value="2">Paraguay</option>
                            <option value="3">Argentina</option>
                            <option value="4">Chile</option>
                            <option value="5">Bolivia</option>
                            <option value="6">Colombia</option>
                            <option value="7">Perú</option>
                            <option value="8">Costa Rica</option>
                            <option value="9">Panamá</option>
                        </select>
                        {isCountryFilterApplied && <label htmlFor="countries">
                            <span className="close-icon" onClick={handleRemoveCountryFilter}>
                                <CloseIcon width={12} />
                            </span>
                        </label>}
                    </div>

                    <div className="select-container">
                        <select
                            name="countries"
                            id="countries"
                            className="countries-select"
                            onChange={handleMonthFilterChange}
                            value={selectedMonthValue}
                        >
                            <option value="" disabled hidden>Filtrar por mes</option>
                            <option value="">Quitar filtro</option>
                            <option value="1">Enero</option>
                            <option value="2">Febrero</option>
                            <option value="3">Marzo</option>
                            <option value="4">Abril</option>
                            <option value="5">Mayo</option>
                            <option value="6">Junio</option>
                            <option value="7">Julio</option>
                            <option value="8">Agosto</option>
                            <option value="9">Septiembre</option>
                            <option value="10">Octubre</option>
                            <option value="11">Noviembre</option>
                            <option value="12">Diciembre</option>
                        </select>
                        {isMonthFilterApplied && <label htmlFor="countries">
                            <span className="close-icon" onClick={handleRemoveMonthFilter}>
                                <CloseIcon width={12} />
                            </span>
                        </label>}
                    </div>
                </div>

                {!!futureEvents.length ?
                    <>
                        {futureEvents.slice(0, visibleEvents).filter((event) => event.show).map((event, index) => (
                            <EventItem data={event} key={`event-${index}`} />
                        ))}

                        {visibleEvents < filteredEvents.length &&
                            <div className="action-container">
                                <button onClick={handleShowMore} className="show-more">VER MÁS</button>
                            </div>
                        }
                    </>
                    :
                    <div className="not-found-events-container">
                        <span className="text">No se econtraron eventos con los filtros seleccionados</span>
                    </div>
                }
            </div>

            {!!pastEvents.length && <EventCarousel data={pastEvents} />}
        </PageLayout>
    )
}

export default withApollo(
    withContext(withTranslation(withAuth(withGlobalComponents(Eventos))), {
        withDummyContext: false,
        withFiltersContext: false,
        withConfigContext: true,
        withThemeContext: true,
    })
);